import React from 'react'

const MainContainer = (props) => {
  const { children, zoom } = props;
  let classes = "main-container";
  if (zoom) classes += " expanded"
  return (
    <div className={classes}>{ children }</div>
  )
}

export default MainContainer